import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { AudioFileForm } from "../AudioFileForm";
import { EditAudioFileModalProps } from "./types";
import { useEditAudioFileModal } from "./controller";

export const EditAudioFileModal = React.memo(({ modalRef, onComplete }: EditAudioFileModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditAudioFileModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("v1/audiobook_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <AudioFileForm />
    </Modal>
  );
});
